package com.shadowings.gero.util

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.FirebaseUser
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.auth.externals.GoogleAuthProvider
import dev.gitlive.firebase.auth.externals.signInWithPopup
import dev.gitlive.firebase.auth.js
import kotlinx.coroutines.await

actual class GoogleSignInHelper actual constructor() {
    actual suspend fun signIn(): Result<FirebaseUser> {
        return try {
            signInWithPopup(Firebase.auth.js, GoogleAuthProvider()).await()
            val user = Firebase.auth.currentUser
                ?: return Result.failure(Exception("Google Sign-In fallito: nessun utente restituito"))
            Result.success(user)
        } catch (e: Throwable) {
            Result.failure(e)
        }
    }
}
